/**
 * Uygulama giriş noktası.
 *
 * Üç sağlayıcı: React kökü · sorgu istemcisi · yönlendirici.
 * `StrictMode` GELİŞTİRMEDE efektleri iki kez çalıştırır — bu bir hata değil,
 * temizlik fonksiyonu eksik olan efektleri ortaya çıkarmak için tasarlanmış
 * bir denetim.
 */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';

import './styles.css';
import { oturumDusmesiniIzle } from './auth/expiry.ts';
import { createQueryClient } from './lib/query.ts';
import { router } from './router.tsx';

/*
 * ÖNİZLEME İSKELESİ — yalnız `VITE_PREVIEW=1` derlemesinde.
 * Dinamik ve koşullu import: bayrak yokken paketleyici dalı tamamen eler,
 * üretim paketine tek satır girmez.
 */
if (import.meta.env.VITE_PREVIEW === '1') {
  const { installPreviewMock } = await import('./preview-mock.ts');
  installPreviewMock();
}

const root = document.getElementById('root');
if (!root) throw new Error('#root bulunamadı');

const queryClient = createQueryClient();

/*
 * Oturum ORTA YERDE düşerse (S37) kullanıcı girişe götürülür. Bağlantı
 * burada kuruluyor çünkü `api.ts` React'i, `RequireSession` de tek tek
 * isteklerin sonucunu bilmez — `auth/expiry.ts` ikisinin arasındaki tercüman.
 * Uygulama ömrü boyunca yaşar; aboneliği bırakmaya gerek yok.
 */
oturumDusmesiniIzle(queryClient);

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
